import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views/home/home.module').then((modue: any) => modue.HomePageModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((modue: any) => modue.LoginModule),
  },
  {
    path: 'splash',
    loadChildren: () => import('./splash-screen/splash-screen.module').then((module) => module.SplashScreenModule),
  },
  {
    path: 'intro',
    loadChildren: () => import('./intro/intro.module').then( m => m.IntroPageModule)
  },
  {
    path: 'help',
    loadChildren: () => import('./help/help.module').then( m => m.HelpPageModule)
  },
  {
    path: 'faq-help',
    loadChildren: () => import('./help/faq-help/faq-help.module').then( m => m.FaqHelpPageModule)
  },
  {
    path: 'signin',
    loadChildren: () => import('./signin/signin.module').then( m => m.SigninPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then( m => m.ProfilePageModule)
  },
  // Rede de segurança para URLs legadas (08/2026). As páginas soltas de perfil
  // foram removidas: quem edita esses dados agora é o <app-profile-menu-sheet>,
  // em views internas (/profile?view=...). Nada no app navega para cá — estas
  // entradas existem só para que histórico, bookmark ou o location.back() de
  // ProfilePage#closePage caiam numa tela viva, já que o app não tem rota
  // wildcard e um path sem match trava a navegação em silêncio.
  // `pathMatch: 'full'` é obrigatório: no 'prefix' o sufixo seria preservado
  // (/person/x → /profile/x), gerando outra URL inexistente.
  // Remover após ~2 releases.
  { path: 'update-profile',            redirectTo: 'profile', pathMatch: 'full' },
  { path: 'person',                    redirectTo: 'profile', pathMatch: 'full' },
  { path: 'address',                   redirectTo: 'profile', pathMatch: 'full' },
  { path: 'socials',                   redirectTo: 'profile', pathMatch: 'full' },
  { path: 'contacts',                  redirectTo: 'profile', pathMatch: 'full' },
  { path: 'custom-section/:sectionId', redirectTo: 'profile', pathMatch: 'full' },
  {
    path: 'entry-carteira',
    loadChildren: () => import('./carteira/entry-carteira/entry-carteira.module').then( m => m.EntryCarteiraPageModule)
  },
  {
    path: 'config-pix',
    loadChildren: () => import('./carteira/config-pix/config-pix.module').then( m => m.ConfigPIXPageModule)
  },
  {
    path: 'mission-detail/:missionId',
    loadChildren: () => import('./mission-detail/mission-detail.module').then( m => m.MissionDetailPageModule)
  },
  {
    path: 'password',
    loadChildren: () => import('./password/password.module').then( m => m.PasswordPageModule)
  },
  {
    path: 'kyc/callback',
    loadChildren: () => import('./kyc-callback/kyc-callback.module').then( m => m.KycCallbackPageModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./notifications/notifications.module').then( m => m.NotificationsPageModule)
  },
  {
    path: 'changelog',
    loadChildren: () => import('./changelog/changelog.module').then( m => m.ChangelogPageModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('./chat/channels/channels.module').then(m => m.ChannelsModule),
  },
  {
    path: 'chat/:channelId',
    loadChildren: () => import('./chat/chat-detail/chat-detail.module').then(m => m.ChatDetailModule),
  },
  {
    path: 'admin-notifications',
    loadChildren: () => import('./admin-notifications/admin-notifications.module').then(m => m.AdminNotificationsModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
